import hyperform from 'hyperform';
hyperform(window, {
  validEvent: false,
});
